export function toUiFieldPath(fieldPath: string): string {
  if (fieldPath === 'zip') return 'zipcode'
  if (fieldPath === 'brokerage_name') return 'brokerageName'
  if (fieldPath === 'license_number') return 'licenseNumber'
  if (fieldPath === 'theme.colors.primary') return 'primaryColor'
  if (fieldPath === 'theme.colors.secondary') return 'secondaryColor'
  return fieldPath
}

/**
 * Maps API dot-paths to flat onboarding wizard keys for `data-ai-field` / highlights
 * on the enter-data step (company phone lives on ambassador.phone in the API).
 */
export function toOnboardingWizardHighlightField(
  fieldPath: string,
  activeStepId: string | null | undefined
): string {
  const slug = activeStepId ?? ''
  if (slug !== 'enter-data' && slug !== 'basic-info') {
    return toUiFieldPath(fieldPath)
  }
  if (fieldPath === 'contactPerson.firstname' || fieldPath === 'contact.general.firstname') {
    return 'contactFirstName'
  }
  if (fieldPath === 'contactPerson.lastname' || fieldPath === 'contact.general.lastname') {
    return 'contactLastName'
  }
  if (fieldPath === 'contactPerson.phone' || fieldPath === 'contact.general.phone') {
    return 'contactPhone'
  }
  if (fieldPath === 'contactPerson.email' || fieldPath === 'contact.general.email') {
    return 'contactEmail'
  }
  if (fieldPath === 'ambassador.phone') return 'phone'
  if (fieldPath === 'ambassador.mobile') return 'ambassadorMobile'
  if (fieldPath === 'ambassador.salutation') return 'ambassadorSalutation'
  if (fieldPath === 'ambassador.firstname') return 'ambassadorFirstName'
  if (fieldPath === 'ambassador.lastname') return 'ambassadorLastName'
  if (fieldPath === 'ambassador.role') return 'ambassadorRole'
  if (fieldPath === 'ambassador.email') return 'ambassadorEmail'
  if (fieldPath === 'ambassador.commission' || fieldPath === 'commission') return 'commission'
  return toUiFieldPath(fieldPath)
}
